import React, {useEffect, useRef, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {api} from "../utils/gashtaltAPI";
import {toPersianNumber} from "../utils/numberConversion";
import Loader from "../components/Loader";
import {toast} from "react-toastify";
import {MdDelete, MdOutlineAddCircle} from "react-icons/md";
import FileInput from "../components/FileInput";
import {getJalaliDate} from "../utils/dateConversion";
import AdminQuestionCard from "../components/AdminQuestionCard";
import {useDispatch} from "react-redux";

function Exam() {
    const {examId} = useParams();
    const [exam, setExam] = useState(null);
    const [questions, setQuestions] = useState([]);
    const [newQuestion, setNewQuestion] = useState(false);
    const [refresh, setRefresh] = useState(true);
    const [loading,setLoading] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    useEffect(() => {
        const fetchData = async () => {
            setNewQuestion(false);
            try {
                const response = await api.get(`/api/exam/${examId}`);
                setExam(response.data.data);
                setQuestions(response.data.data.questions);
                setLoading(false);
            } catch (error) {
                console.log('ERROR')
            } finally {
                setLoading(false);
            }
            setRefresh(false)
        }
        if (refresh) fetchData();
    }, [refresh]);
    const onFileChange = async (event, type) => {
        setLoading(true);
        const file = (event.target.files[0]);
        try {
            const formData = new FormData();
            formData.append("file", file);
            const response = await api.post(`/api/exam/${examId}/upload/${type}`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }

            });
            setRefresh(true)
            if(type==="questions"){
                try {
                    const response = await api.post(`/api/exam/${examId}/convertPDF`);
                    toast.success(response.data.message, {
                        position: "bottom-right"
                    });
                } catch (error) {
                    if (error.response) {
                        const status = error.response.status;
                        if (status === 422 || status === 401) {
                            toast.error(error.response.data.message, {
                                position: "bottom-right"
                            });
                        }
                        return;
                    } else if (error.request) {
                        toast.error("اتصال اینترنت خود را بررسی کنید!", {
                            position: "bottom-right"
                        });
                        return;
                    }
                    toast.error("خطایی در تبدیل پی دی اف به عکس رخ داد!", {
                        position: "bottom-right"
                    });
                } finally {
                    setLoading(false);
                }
            }
            toast.success(response.data.message, {
                position: "bottom-right"
            });
        } catch (error) {
            if (error.response) {
                const status = error.response.status;
                if (status === 422 || status === 401) {
                    toast.error(error.response.data.message, {
                        position: "bottom-right"
                    });
                }
                return;
            } else if (error.request) {
                toast.error("اتصال اینترنت خود را بررسی کنید!", {
                    position: "bottom-right"
                });
                return;
            }
            toast.error("خطایی رخ داد!", {
                position: "bottom-right"
            });
        } finally {
            setLoading(false);
        }
    };
    const deleteFile = async (type) => {
        setLoading(true);
        try {
            const response = await api.get(`/api/exam/${examId}/upload/delete/${type}`);
            setRefresh(true)
            toast.success(response.data.message, {
                position: "bottom-right"
            });
        } catch (error) {
            if (error.response) {
                const status = error.response.status;
                if (status === 422 || status === 401) {
                    toast.error(error.response.data.message, {
                        position: "bottom-right"
                    });
                }
                return;
            } else if (error.request) {
                toast.error("اتصال اینترنت خود را بررسی کنید!", {
                    position: "bottom-right"
                });
                return;
            }
            toast.error("خطایی رخ داد!", {
                position: "bottom-right"
            });
        } finally {
            setLoading(false);
        }
    };
    if (loading) return <Loader />
    return (<>
        <div className="py-3 text-center">
            <h3>{exam?.name} <span
                className={"mx-1"}>({exam?.price === 0 ? 'رایگان' : toPersianNumber(exam?.price) + ' تومان '})</span>
            </h3>
            <div className="row align-items-center py-2 px-5"
                 style={{borderBottom: "3px solid #EAEAEA"}}>
                <div className={'d-flex gap-3 justify-content-start col-lg-4'}>
                    <button className="btn btn-outline-red" onClick={() => {
                        navigate(-1)
                    }}>بازگشت
                    </button>
                    {!exam?.questions_file ?
                        <FileInput text={'سوالات'} className={'btn-outline-blue'} onChange={(e) => {
                            onFileChange(e, 'questions')
                        }}/> :
                        (
                            <button className={`btn btn-outline-red d-flex flex-row align-items-center gap-2`}
                                    onClick={() => {
                                        deleteFile('questions')
                                    }}>
                                حذف فایل سوالات
                                <MdDelete/>
                            </button>

                        )}
                    {!exam?.answers_file ?
                        <FileInput text={'پاسخنامه'} className={'btn-outline-green'} onChange={(e) => {
                            onFileChange(e, 'answers')
                        }}/> :
                        (
                            <button className={`btn btn-outline-red d-flex flex-row align-items-center gap-2`}
                                    onClick={() => {
                                        deleteFile('answers')
                                    }}>
                                حذف فایل پاسخنامه
                                <MdDelete/>
                            </button>
                        )}
                    <button className={`btn btn-outline-blue d-flex flex-row align-items-center gap-2`}
                            onClick={() => {
                                setNewQuestion(true)
                            }}>
                        سوال
                        <MdOutlineAddCircle />
                    </button>
                </div>
                <div className={'col-lg-4 col-6 mt-3 d-flex justify-content-center gap-3'}>
                    <span className="badge text-bg-success text-dark date-info" dir="ltr">
                        {toPersianNumber(getJalaliDate(exam?.startDate))}
                    </span>
                    <span className="badge text-bg-success text-dark date-info" dir="ltr">
                        {toPersianNumber(getJalaliDate(exam?.endDate))}
                    </span>
                </div>
                <p className="m-0 mt-3 col-lg-4 col-6 text-end">
                    زمان :
                    <span>{toPersianNumber(exam?.duration) + " دقیقه"}</span>
                </p>
            </div>
        </div>
        {questions.map((question, index) => (
            <AdminQuestionCard examId={examId} id={question.id} index={index}
                               currentQuestionText={question.question_text} currentImage={question.image}
                               currentShowUnder={question.show_under} currentOptions={question.options}
                               deleteHandler={()=>{setQuestions(prevQuestions => prevQuestions.filter((tquestion, i) => tquestion.id  !== question.id));}}/>

        ))}
        {newQuestion && (<AdminQuestionCard examId={examId} index={questions.length} newQuestion={true} handler={(question) => {
            setQuestions([...questions, question]);
            setNewQuestion(false);
        }} deleteHandler={()=>{setNewQuestion(false)}}/>)}
    </>);
}

export default Exam;